var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 24h1.2v-2.4h-1.2v-1.2a8.42 8.42 0 0 0-4.12-7.22 1.28 1.28 0 0 1-.68-1.09v-.18c0-.43.25-.83.68-1.08A8.42 8.42 0 0 0 20.4 3.6V2.4h1.2V0H2.4v2.4h1.2v1.2a8.42 8.42 0 0 0 4.12 7.23c.43.25.68.65.68 1.08v.18c0 .43-.25.83-.68 1.08A8.42 8.42 0 0 0 3.6 20.4v1.2H2.4V24h18ZM18 2.4v1.2a6 6 0 0 1-1.2 3.6H7.2A6 6 0 0 1 6 3.6V2.4h12ZM8.94 15.24a3.66 3.66 0 0 0 1.86-3.15V12h2.4v.1c0 1.28.7 2.45 1.86 3.14A5.98 5.98 0 0 1 17.5 18h-11a5.97 5.97 0 0 1 2.43-2.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.8f4ce01788265787cb8087f60ee5d7b4.svg";
export { ForwardRef as ReactComponent };